/* eslint-disable max-len */
import React, { useState, useEffect, useCallback } from "react";
import PropTypes from "prop-types";
import { useSelections } from "../../context/Selections";

function Kpi({ app, objectId, updatesWithSelection }) {
	const [kpi, setKpi] = useState(null);
	const { selections } = useSelections();

	const fetchKPIValue = useCallback(
		async (objectId) => {
			if (app && objectId) {
				let id = objectId;
				await app.visualization.get(id).then((res) => {
					const value =
						res?.model?.layout?.qHyperCube?.qGrandTotalRow[0]
							?.qText ??
						res?.model?.layout?.qHyperCube?.qGrandTotalRow[0]
							?.qNum ??
						null;
					setKpi(value && value[0] !== "-" ? value : null);
				});
			}
		},
		[app, setKpi]
	);

	useEffect(() => {
		if (updatesWithSelection) {
			fetchKPIValue(objectId);
		}
	}, [fetchKPIValue, objectId, selections, updatesWithSelection]);

	return kpi;
}

Kpi.defaultProps = {
	app: null,
	objectId: "",
	updatesWithSelection: false,
};

Kpi.propTypes = {
	app: PropTypes.object,
	objectId: PropTypes.string,
	updatesWithSelection: PropTypes.bool,
};

export default Kpi;
